import React, { useEffect, useRef} from "react";
import styled from "styled-components";
import { keyframes } from "styled-components";

function TextAnimation() {
  const textref= useRef();
  const reactarray = "My-Projects".split("");
  const pagewidth = window.innerWidth;
  useEffect(() => {
    if (pagewidth <= 960) {
      textref.current.style.marginTop = "150px";
    } 
  });
  return (
    <div ref={textref} >
      <Wrapper>
        {reactarray.map((item, index) => (
          <span style={{fontWeight: "bolder"}} key={index}>{item}</span>
        ))}
      </Wrapper>
    </div>
  );
}

const animation = keyframes`
    0% { opacity: 0; transform: translateY(-100px) skewY(10deg) skewX(10deg) rotateZ(30deg); filter: blur(10px); }
    25% { opacity: 1; transform: translateY(0px);  skewY(0deg) skewX(0deg) rotateZ(0deg); filter: blur(0px); }
    75% { opacity: 1;  transform: translateY(0px);  skewY(0deg) skewX(0deg) rotateZ(0deg); filter: blur(0px); }
    100% { opacity: 0;  transform: translateY(-100px);  skewY(10deg) skewX(10deg) rotateZ(30deg); filter: blur(10px); }
`;

const Wrapper = styled.h1`
  display: inline-block;
  color: white;

  span{
    display: inline-block;
    animation-name: ${animation};
    animation-duration: 6s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-timing-function: cubic-bezier(0.075, 0.82, 0.165, 1);
  }
  
  span:nth-child(1){
      animation-delay: 0.1s;
  }
  span:nth-child(2){
      animation-delay: 0.2s;
  }
  span:nth-child(3){
      animation-delay: 0.3s;
  }
  span:nth-child(4){
      animation-delay: 0.4s;
  }
  span:nth-child(5){
      animation-delay: 0.5s;
  }
  span:nth-child(6){
      animation-delay: 0.6s;
  }
  span:nth-child(7){
      animation-delay: 0.7s;
  }
  span:nth-child(8){
      animation-delay: 0.8s;
  }
  span:nth-child(9){
      animation-delay: 0.9s;
  }
  span:nth-child(10){
      animation-delay: 1.0s;
  }
  span:nth-child(11){
      animation-delay: 1.1s;
  }
`;

export default TextAnimation;
